import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useInstaller } from '../InstallerDownload';
import AboZustimmung from '../kauf/AboZustimmung';
import { texte } from './texte';

// Die Abschnitte der Startseite als ein Baustein: Werkzeuge, Kostenlos, All-in-One, Installer.
// Startseite und Werkzeuge-Seite (/shop) nutzen dieselben Teile, damit beide gleich aussehen und
// sich gemeinsam ändern. Die Bewegung (Filter, Suche, Panel-Wechsel, Preis-Zähler, Installer-
// Ladebalken, Zeitlinien) setzt starteAbschnitte() aus abschnitte.js an das fertige DOM.
//
// seite="start":     Reihenfolge der Startseite; jeder Abschnitt endet mit einem Knopf zur Unterseite.
// seite="shop":      Werkzeuge zuerst als Seitenüberschrift (h1) mit Suchfeld, dann All-in-One,
//                    Kostenlos (mit Flow Panel) und Installer.
// seite="kostenlos": genauso aufgebaut wie die Werkzeuge-Seite, nur mit den Gratis-Sachen als Hauptbereich.

export function InstallerKnoepfe({ t, en }) {
  const info = useInstaller();
  return (
    <>
      <div className="ctas reveal">
        <a className="btn primaer" href={info ? info.url : undefined} data-testid="start-installer-mac">{t.mac}</a>
        <a className="btn glas" href={info ? info.url_win : undefined} data-testid="start-installer-win">{t.win}</a>
      </div>
    </>
  );
}

// Das animierte Installer-Fenster (Ladebalken setzt starteAbschnitte, sobald es zu sehen ist).
// oben = liegt im ersten Bildschirm (Installer-Seite), dann die Vorschaubilder nicht erst spät laden.
export function InstallerFenster({ T, oben }) {
  return (
    <div className="fenster reveal" id="instfenster">
      <div className="fkopf"><i /><i /><i /><span>David Media Installer</span></div>
      {T.inst.zeilen.map(z => (
        <div className="frow" key={z.name}>
          <img src={z.bild} alt="" loading={oben ? undefined : 'lazy'} />
          <div><b>{z.name}</b><small>{z.klein}</small></div>
          <span className={'status ' + z.status} data-fertig={z.fertig} data-klein-fertig={z.kleinFertig}>
            {z.fertig && <span className="balken" />}<em>{z.em}</em>
          </span>
        </div>
      ))}
      <div className="fuss-leiste"><span>{T.inst.angemeldet}</span><span id="instinfo">{T.inst.offen}</span></div>
    </div>
  );
}

const Zeitlinie = ({ nr }) => <div className="zeitlinie"><b /><i /><span>00:00:0{nr}:00</span></div>;
const Ueberschrift = ({ als: Tag = 'h2', a, b }) => (
  <Tag className={Tag === 'h1' ? 'als-h2' : undefined}><span className="zl"><span>{a}</span></span><span className="zl"><span className="grau">{b}</span></span></Tag>
);
const kicker = (nr, text) => `${String(nr).padStart(2, '0')} · ${text.replace(/^\d+ · /, '')}`;

// Kategorie-Namen beider Sprachen je Filter, damit die Suche auch „Farbe“, „Color“ oder „Layout“ findet
const KAT_NAMEN = {};
[texte(false), texte(true)].forEach(t => [...t.wz.chips, ...t.gr.chips].forEach(([f, name]) => {
  KAT_NAMEN[f] = KAT_NAMEN[f] ? `${KAT_NAMEN[f]} ${name}` : name;
}));

// Titelbilder als 800/1600-px-WebP (products/titel/800, /1600) statt der 2560er-JPGs.
// sizes = Kartenbreite je Raster: 1 Spalte bis 560 px, 2 bis 1000 px, darüber 3/4/6 Spalten.
// Englische Fassungen gleich aufgebaut unter products/titel/en/.
const titelBild = (slug, en) => { const b = `/products/titel/${en ? 'en/' : ''}`; return { src: `${b}800/${slug}.webp`, srcSet: `${b}800/${slug}.webp 800w, ${b}1600/${slug}.webp 1600w` }; };
const SIZES = {
  zwoelf: '(max-width: 560px) calc(100vw - 32px), (max-width: 1000px) 50vw, (max-width: 1279px) 33vw, (min-width: 2200px) 17vw, 25vw',
  vier: '(max-width: 560px) calc(100vw - 32px), (max-width: 1279px) 50vw, 25vw',
  drei: '(max-width: 560px) calc(100vw - 32px), (max-width: 1000px) 50vw, 33vw',
};

// oben = Karte liegt im ersten Bildschirm (erste Reihe der Werkzeuge- bzw. Kostenlos-Seite): nicht lazy laden
function Karte({ to, slug, sizes, oben, name, preis, gratis, text, abo, ansehen, kat, verzoegerung, en }) {
  return (
    <Link className="karte reveal" to={to} data-kat={kat} data-suche={`${name} ${text} ${KAT_NAMEN[kat] || ''}`.toLowerCase()} style={{ transitionDelay: `${verzoegerung}ms` }}>
      <div className="bild" data-ansehen={ansehen}><img {...titelBild(slug, en)} sizes={sizes} alt={name} loading={oben ? undefined : 'lazy'} /></div>
      <div className="info">
        <div className="zeile"><h3>{name}</h3><span className={'preis' + (gratis ? ' gratis' : '')}>{preis}</span></div>
        <p>{text}</p><span className="abo">{abo}</span>
      </div>
    </Link>
  );
}

// „7 Tage kostenlos testen“ in der Preiskarte: öffnet die Zustimmung vor der Abo-Kasse (AboZustimmung) mit der
// Laufzeit, die im Umschalter der Karte gerade an ist (den schaltet starteAbschnitte per DOM, darum hier
// nachlesen). Eigener kleiner Baustein, damit das Öffnen nicht den ganzen Abschnitt neu rendert.
function AboKnopf({ en, text }) {
  const [plan, setPlan] = useState(null);
  const oeffnen = e => {
    const an = e.currentTarget.closest('.preiskarte')?.querySelector('#umschalter button.an');
    setPlan(an && an.dataset.p === 'monat' ? 'monat' : 'jahr');
  };
  return (
    <>
      <button type="button" className="btn primaer" onClick={oeffnen} aria-haspopup="dialog" data-testid="start-aio-testen">{text}</button>
      <AboZustimmung offen={!!plan} plan={plan || 'jahr'} en={en} onZu={() => setPlan(null)} />
    </>
  );
}

// Knopf am Ende eines Abschnitts, der zur passenden Unterseite führt
const Weiter = ({ to, children }) => (
  <div className="weiter reveal"><Link className="btn glas" to={to}>{children} <span aria-hidden="true">→</span></Link></div>
);

// Suchfeld + Filter-Chips des Hauptbereichs einer Seite (nur einmal pro Seite: ids suche/chips)
function Filter({ en, chips, suche, platzhalter }) {
  return (
    <div className="filter reveal">
      {suche && (
        <label className="suche">
          <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" /></svg>
          <input id="suche" type="search" placeholder={platzhalter} aria-label={platzhalter} />
        </label>
      )}
      <div className="chips" id="chips">
        {chips.map(([f, name], i) => (
          <button key={f} className={'chip' + (i ? '' : ' an')} data-f={f}>{name}</button>
        ))}
      </div>
    </div>
  );
}

export default function Abschnitte({ en, seite = 'start' }) {
  const T = texte(en);
  const p = en ? '/en' : '';
  const shop = seite === 'shop';
  const gratisSeite = seite === 'kostenlos';
  const start = seite === 'start';
  const L = {
    werkzeuge: `${p}/shop`,
    kostenlos: en ? '/en/free' : '/kostenlos',
    aio: `${p}/shop/all-in-one`,
    installer: `${p}/installer`,
  };

  const werkzeuge = nr => (
    <section className={'sek' + (shop ? ' erste' : '')} id="werkzeuge" key="werkzeuge">
      <div className="innen">
        {!shop && <Zeitlinie nr={nr} />}
        <div className="kopf">
          <div className="reveal-text">
            <span className="kicker">{kicker(nr, T.wz.kicker)}</span>
            <Ueberschrift als={shop ? 'h1' : 'h2'} a={T.wz.h2a} b={T.wz.h2b} />
            <p className="lead reveal">{T.wz.lead}</p>
          </div>
          {!gratisSeite && <Filter en={en} chips={T.wz.chips} suche={shop} platzhalter={en ? 'Search tools' : 'Werkzeug suchen'} />}
        </div>
        <div className="raster" id={gratisSeite ? 'werkzeug-raster' : 'raster'}>
          {T.werkzeuge.map((w, i) => (
            <Karte key={w.slug} en={en} to={`${p}/shop/${w.slug}`} slug={w.slug} sizes={SIZES.zwoelf} oben={shop && i < 4} name={w.name} preis={w.preis}
              text={w.text} abo={T.wz.abo} ansehen={T.wz.ansehen} kat={w.kat} verzoegerung={(i % 4) * 70} />
          ))}
        </div>
        {shop && <p className="leer" id="leer" hidden>{en ? 'No tool matches your search.' : 'Kein Werkzeug passt zu deiner Suche.'}</p>}
        {!shop && <Weiter to={L.werkzeuge}>{en ? 'See all tools' : 'Alle Werkzeuge ansehen'}</Weiter>}
      </div>
    </section>
  );

  const gratisListe = start ? T.gratis : [T.flowPanel, ...T.gratis];
  const kostenlos = nr => (
    <section className={'sek' + (gratisSeite ? ' erste' : '')} id="kostenlos" key="kostenlos">
      <div className="innen">
        {!gratisSeite && <Zeitlinie nr={nr} />}
        <div className="kopf">
          <div className="reveal-text">
            <span className="kicker">{kicker(nr, T.gr.kicker)}</span>
            <Ueberschrift als={gratisSeite ? 'h1' : 'h2'} a={T.gr.h2a} b={T.gr.h2b} />
            <p className="lead reveal">{T.gr.lead}</p>
          </div>
          {gratisSeite && <Filter en={en} chips={T.gr.chips} suche platzhalter={en ? 'Search free stuff' : 'Gratis-Sachen suchen'} />}
        </div>
        <div className={'raster ' + (gratisListe.length === 4 ? 'vier' : 'drei')} id={gratisSeite ? 'raster' : 'gratis'}>
          {gratisListe.map((g, i) => (
            <Karte key={g.slug} en={en} to={`${p}/shop/${g.slug}`} slug={g.slug} sizes={gratisListe.length === 4 ? SIZES.vier : SIZES.drei} oben={gratisSeite} name={g.name} preis={T.gr.preis} gratis
              text={g.text} abo={g.abo || T.gr.abo} ansehen={T.wz.ansehen} kat={g.kat} verzoegerung={i * 70} />
          ))}
        </div>
        {gratisSeite && <p className="leer" id="leer" hidden>{en ? 'Nothing matches your search.' : 'Nichts passt zu deiner Suche.'}</p>}
        {!gratisSeite && <Weiter to={L.kostenlos}>{en ? 'See all free stuff' : 'Alle Gratis-Sachen ansehen'}</Weiter>}
      </div>
    </section>
  );

  const allInOne = nr => (
    <section className="sek" id="all-in-one" key="all-in-one">
      <div className="innen">
        <Zeitlinie nr={nr} />
        <div className="kopf">
          <div className="reveal-text">
            <span className="kicker">{kicker(nr, T.aio.kicker)}</span>
            <Ueberschrift a={T.aio.h2a} b={T.aio.h2b} />
            <p className="lead reveal">{T.aio.lead}</p>
          </div>
        </div>
        <div className="studio">
          <div className="panelseite reveal">
            <div className="panel-licht" />
            <div className="fenster panel" id="panel"><div className="ptitel" id="ptitel">Studio Flow</div></div>
          </div>
          <div className="tabs" id="tabs" />
          <div className="preiskarte reveal" style={{ transitionDelay: '.12s' }}>
            <div className="umschalter" id="umschalter">
              <button data-p="monat">{T.aio.monatlich}</button>
              <button data-p="jahr" className="an">{T.aio.jaehrlich}</button>
            </div>
            <div className="betrag"><span id="betrag">{T.preise.jahr.format(T.preise.jahr.betrag)}</span> <small id="einheit">{T.preise.jahr.einheit}</small></div>
            <div className="unter" id="unter">{T.preise.jahr.unter}</div>
            <ul className="haken">{T.aio.haken.map(h => <li key={h}>{h}</li>)}</ul>
            <div className="anker">{T.aio.anker}</div>
            <AboKnopf en={en} text={T.aio.testen} />
            <div className="mikro">{T.aio.mikro}</div>
          </div>
        </div>
        <Weiter to={L.aio}>{en ? 'All-in-One in detail' : 'All-in-One im Detail'}</Weiter>
      </div>
    </section>
  );

  const installer = nr => (
    <section className="sek" id="installer" key="installer">
      <div className="innen">
        <Zeitlinie nr={nr} />
        <div className="inst">
          <InstallerFenster T={T} />
          <div className="reveal-text">
            <span className="kicker">{kicker(nr, T.inst.kicker)}</span>
            <Ueberschrift a={T.inst.h2a} b={T.inst.h2b} />
            <p className="lead reveal">{T.inst.lead}</p>
            <ol className="schritte reveal">
              {T.inst.schritte.map(([fett, rest]) => <li key={fett}><span><b>{fett}</b>{rest}</span></li>)}
            </ol>
            <InstallerKnoepfe t={T.inst} en={en} />
            <div className="weiter-text reveal"><Link to={L.installer}>{en ? 'Installer: step by step' : 'Installer: so geht’s Schritt für Schritt'} <span aria-hidden="true">→</span></Link></div>
          </div>
        </div>
      </div>
    </section>
  );

  const reihenfolge = shop ? [werkzeuge, allInOne, kostenlos, installer]
    : gratisSeite ? [kostenlos, werkzeuge, allInOne, installer]
    : [werkzeuge, kostenlos, allInOne, installer];
  return <>{reihenfolge.map((abschnitt, i) => abschnitt(i + 1))}</>;
}
